import locale from 'date-fns/locale/ru';
import dfFormat from 'date-fns/format';
import dfParseISO from 'date-fns/parseISO';
import dfIsThisYear from 'date-fns/isThisYear';
import dfFormatDistanceToNow from 'date-fns/formatDistanceToNow';
import compareAsc from 'date-fns/compareAsc';

let formatDict = {
  dateFull: 'dd MMMM, HH:mm',
  dateFullYear: 'dd MMMM yyyy, HH:mm',
  date: 'dd MMMM',
  dateYear: 'dd MMMM yyyy',
  fullTime: 'HH:mm:ss',
  time: 'HH:mm',
};

const getFormat = (formatString, date) => {
  let format = formatString;
  if (formatDict[formatString]) {
    format = formatDict[formatString];
    if (date && !dfIsThisYear(date) && formatDict[formatString + 'Year']) {
      format = formatDict[formatString + 'Year'];
    }
  }
  return format;
};

export function parse(date) {
  if (typeof date == 'string') {
    return new Date(date);
  }
  return date;
}

export function format(date, formatString = 'dateFull') {
  if (!date) {
    return '';
  }

  if (typeof date == 'string') {
    date = dfParseISO(date);
  }

  return dfFormat(date, getFormat(formatString, date), { locale });
}

export function dayFormat(date, formatString = 'dateFull') {
  if (!date) {
    return '';
  }

  if (typeof date == 'string') {
    date = dfParseISO(date);
  }

  return dfFormat(date, getFormat(formatString, date), { locale }).split(',')[0];
}

export function dateToNow(date, addSuffix = false, includeSeconds = false) {
  return dfFormatDistanceToNow(parse(date), { locale, addSuffix, includeSeconds });
}

export function compareDatesAsString(dateAsString1, dateAsString2) {
  return compareAsc(new Date(dateAsString2), new Date(dateAsString1));
}

export default {
  parse,
  format,
  dayFormat,
  dateToNow,
  compareDatesAsString,
};
